import { create } from 'zustand';
import { shallow } from 'zustand/shallow';

type State = {
  family: any;
};

type Actions = {
  setFamily: (family: any) => void;
  resetFamily: () => void;
};

const initialState: State = {
  family: null,
};

const useMyFamilyStoreBase = create<State & Actions>()(set => ({
  ...initialState,
  setFamily: family => set({ family }),
  resetFamily: () => set(initialState),
}));

export const useMyFamilyStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useMyFamilyStoreBase(selector, shallow);
};
